import { render, staticRenderFns } from "./CoordinatorDashboard.vue?vue&type=template&id=068955b8&"
import script from "./CoordinatorDashboard.vue?vue&type=script&lang=js&"
export * from "./CoordinatorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports